import React, { useEffect, useState, useRef } from 'react'

const Dropdown = ({ menu }) => {

    const [open, setOpen] = useState(false)
    const ref = useRef()

    useEffect(() => {
        const onBodyClick = event =>{
            if(ref.current && ref.current.contains(event.target)){
                return
            }
            setOpen(false)
        }

        document.body.addEventListener("click",onBodyClick)
        return () => {
            document.body.removeEventListener("click",onBodyClick)
        }
    }, [])

    return (
        <li ref={ref} className={`dropdown ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
            <a href="#/" target="_self" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                <span>{menu.label}</span>
                <span className="caret"></span>
            </a>
            <ul className="dropdown-menu">
                {menu.submenuItems.map((item,i) => (
                    <li key={`key-${i}`} className="">
                        <a href={item.link} target="_self">
                            <span>{item.label}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </li>
    )
}

export default Dropdown